export default function ChatgptExplain() {
  return <h2>Chatgpt Explain</h2>;
}
